export const ALL = 'All'
export const COLLEGES = 'Colleges'
